import {
    useTheme,  Button, Dialog, 
    DialogActions,
    DialogContent,


} from "@mui/material";



import ReportParentRollProductionMAWiseBalanceQty from "../../features/production/reports/ParentRollMAWiseBalanceQty";
import { tokens } from "../../theme/theme";
import ReportWinderProuctionWIPReelsList from "../../features/production/reports/ReportWinderProuctionWIPReelsList";



const DialogBox = ({ open, onClose, modulename }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const handleCallBack = () => {

    }



    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                style: {
                    alignSelf: 'flex-start',
                    margin: '0 auto',
                    position: 'relative',
                    top: '0px',
                },
            }}
            BackdropProps={{
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    paddingTop: '20px',
                    minHeight: '100vh',
                    background: 'rgba(0,0,0,0.5)',
                },
            }}
        >

            <DialogContent style={{ backgroundColor: colors.primary[500], color: colors.primary }}>

                {modulename === 'paper-roll-production-ma-wise-balance-qty' && (
                    <ReportParentRollProductionMAWiseBalanceQty handleBackWinderMachineEntry={handleCallBack} mode={1} />
                ) || (null)}

  {modulename === 'winder-machine_wip_reels_report' && (
                    <ReportWinderProuctionWIPReelsList handleBackWinderMachineEntry={handleCallBack} mode={1} />
                ) || (null)}

            </DialogContent>

            <DialogActions style={{ backgroundColor: colors.primary[400] }}>
                <Button size='small' variant="contained" color="secondary" onClick={() => { onClose(); }} style={{ textTransform: 'none' }} >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>




    )
}
export default DialogBox;